// form
// @mui
import { Checkbox, FormControlLabel, FormControlLabelProps, FormGroup } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

// ----------------------------------------------------------------------

interface RHFCheckboxProps extends Omit<FormControlLabelProps, "control"> {
	name: string;
}

export function RHFCheckbox({ name, ...other }: RHFCheckboxProps) {
	const { control } = useFormContext();

	return (
		<FormControlLabel
			control={
				<Controller
					control={control}
					name={name}
					render={({ field }) => (
						<Checkbox
							{...field}
							checked={field.value}
							size={"small"}
							sx={{ ...other, ...other.sx }}
						/>
					)}
				/>
			}
			{...other}
		/>
	);
}

// ----------------------------------------------------------------------

interface RHFMultiCheckboxProps extends Omit<FormControlLabelProps, "control" | "label"> {
	name: string;
	options: string[];
}

export function RHFMultiCheckbox({ name, options, ...other }: RHFMultiCheckboxProps) {
	const { control } = useFormContext();

	return (
		<Controller
			control={control}
			name={name}
			render={({ field }) => {
				const onSelected = (option: string) =>
					field.value.includes(option)
						? field.value.filter((value: string) => value !== option)
						: [...field.value, option];

				return (
					<FormGroup>
						{options.map((option) => (
							<FormControlLabel
								control={
									<Checkbox
										checked={field.value.includes(option)}
										onChange={() => field.onChange(onSelected(option))}
									/>
								}
								key={option}
								label={option}
								{...other}
							/>
						))}
					</FormGroup>
				);
			}}
		/>
	);
}
